import WorkflowEmpresaDisenoPage from '../configuracion/workflow/workflow-empresa/workflow-empresa-diseno-page';

export default function WorkflowAppEmpresaDisenoPage() {
  return <WorkflowEmpresaDisenoPage variant="app" />;
}
